export const GENDERS = [
  {
    value: 'male',
    label: 'Nam',
  },
  {
    value: 'female',
    label: 'Nữ',
  },
  {
    value: 'other',
    label: 'Khác',
  },
];
export const TO_GENDER = {
  1: 'Nam',
  2: 'Nữ',
  3: 'Khác',
} as any;
export const ERROR = {
  TOKEN_NOT_FOUND: 'TOKEN_NOT_FOUND',
  INVALID_TOKEN: 'INVALID_TOKEN',
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
  FORBIDDEN: 'FORBIDDEN',
  UNAUTHORIZED_ACCESS: 'UNAUTHORIZED_ACCESS',
  RESOURCE_NOT_FOUND: 'RESOURCE_NOT_FOUND',
  INCORRECT_CREDENTIAL: 'INCORRECT_CREDENTIAL',
  ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
  MISSING_PARAMETERS: 'MISSING_PARAMETERS',
  MISSING_DATA: 'MISSING_DATA',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
  DATA_INCORRECT_FORMAT: 'DATA_INCORRECT_FORMAT',
  INVALID_DATA: 'INVALID_DATA',
  DATA_ALREADY_EXISTS: 'DATA_ALREADY_EXISTS',
  DATA_IS_BINDING: 'DATA_IS_BINDING',
  LIST_IS_DUPLICATED: 'LIST_IS_DUPLICATED ',
  DATA_IS_CONFLICT: 'DATA_IS_CONFLICT',
  RESOURCE_HAS_EXPIRED: 'RESOURCE_HAS_EXPIRED',
};

export const REGEXR = {
  phone: /^(?:\+84|0)(?:[3|5|7|8|9]\d{8}|1[2|6|8|9]\d{7})$/,
};

export const PENALTY_TICKET_STATUS = {
  1: 'Chưa thanh toán',
  2: 'Đã thanh toán',
};

export const PERMISSIONS = {
  USER_CREATE: 'USER_CREATE',
  USER_UPDATE: 'USER_UPDATE',
  USER_DELETE: 'USER_DELETE',
  USER_VIEW: 'USER_VIEW',

  ACCOUNT_CREATE: 'ACCOUNT_CREATE',
  ACCOUNT_UPDATE: 'ACCOUNT_UPDATE',
  ACCOUNT_DELETE: 'ACCOUNT_DELETE',
  ACCOUNT_VIEW: 'ACCOUNT_VIEW',

  BOOK_CREATE: 'BOOK_CREATE',
  BOOK_UPDATE: 'BOOK_UPDATE',
  BOOK_DELETE: 'BOOK_DELETE',
  BOOK_VIEW: 'BOOK_VIEW',

  BOOK_REQUEST_CREATE: 'BOOK_REQUEST_CREATE',
  BOOK_REQUEST_UPDATE: 'BOOK_REQUEST_UPDATE',
  BOOK_REQUEST_DELETE: 'BOOK_REQUEST_DELETE',
  BOOK_REQUEST_VIEW: 'BOOK_REQUEST_VIEW',

  POSITION_CREATE: 'POSITION_CREATE',
  POSITION_UPDATE: 'POSITION_UPDATE',
  POSITION_DELETE: 'POSITION_DELETE',
  POSITION_VIEW: 'POSITION_VIEW',

  CATEGORY_CREATE: 'CATEGORY_CREATE',
  CATEGORY_UPDATE: 'CATEGORY_UPDATE',
  CATEGORY_DELETE: 'CATEGORY_DELETE',
  CATEGORY_VIEW: 'CATEGORY_VIEW',

  FINE_POLICY_CREATE: 'FINE_POLICY_CREATE',
  FINE_POLICY_UPDATE: 'FINE_POLICY_UPDATE',
  FINE_POLICY_DELETE: 'FINE_POLICY_DELETE',
  FINE_POLICY_VIEW: 'FINE_POLICY_VIEW',

  LOAN_RECEIPT_CREATE: 'LOAN_RECEIPT_CREATE',
  LOAN_RECEIPT_UPDATE: 'LOAN_RECEIPT_UPDATE',
  LOAN_RECEIPT_DELETE: 'LOAN_RECEIPT_DELETE',
  LOAN_RECEIPT_VIEW: 'LOAN_RECEIPT_VIEW',
  LOAN_RECEIPT_EXTEND: 'LOAN_RECEIPT_EXTEND',

  PENALTY_TICKET_DELETE: 'PENALTY_TICKET_DELETE',
  PENALTY_TICKET_PAY: 'PENALTY_TICKET_PAY',
  PENALTY_TICKET_VIEW: 'PENALTY_TICKET_VIEW',

  BOOK_LOST_CREATE: 'BOOK_LOST_CREATE',
  BOOK_LOST_UPDATE: 'BOOK_LOST_UPDATE',
  BOOK_LOST_DELETE: 'BOOK_LOST_DELETE',
  BOOK_LOST_VIEW: 'BOOK_LOST_VIEW',

  FIELD_CREATE: 'FIELD_CREATE',
  FIELD_UPDATE: 'FIELD_UPDATE',
  FIELD_DELETE: 'FIELD_DELETE',
  FIELD_VIEW: 'FIELD_VIEW',

  LANGUAGE_CREATE: 'LANGUAGE_CREATE',
  LANGUAGE_UPDATE: 'LANGUAGE_UPDATE',
  LANGUAGE_DELETE: 'LANGUAGE_DELETE',
  LANGUAGE_VIEW: 'LANGUAGE_VIEW',

  PUBLISHER_CREATE: 'PUBLISHER_CREATE',
  PUBLISHER_UPDATE: 'PUBLISHER_UPDATE',
  PUBLISHER_DELETE: 'PUBLISHER_DELETE',
  PUBLISHER_VIEW: 'PUBLISHER_VIEW',

  YEAR_SCHOOL_CREATE: 'YEAR_SCHOOL_CREATE',
  YEAR_SCHOOL_UPDATE: 'YEAR_SCHOOL_UPDATE',
  YEAR_SCHOOL_DELETE: 'YEAR_SCHOOL_DELETE',
  YEAR_SCHOOL_VIEW: 'YEAR_SCHOOL_VIEW',

  CLASS_CREATE: 'CLASS_CREATE',
  CLASS_UPDATE: 'CLASS_UPDATE',
  CLASS_DELETE: 'CLASS_DELETE',
  CLASS_VIEW: 'CLASS_VIEW',

  BOOK_STATUS_CREATE: 'BOOK_STATUS_CREATE',
  BOOK_STATUS_UPDATE: 'BOOK_STATUS_UPDATE',
  BOOK_STATUS_DELETE: 'BOOK_STATUS_DELETE',
  BOOK_STATUS_VIEW: 'BOOK_STATUS_VIEW',

  REPORT_LOAN_GIVE_BOOK: 'REPORT_LOAN_GIVE_BOOK',
  REPORT_READER: 'REPORT_READER',
  REPORT_BOOK: 'REPORT_BOOK',

  SCHOOL_UPDATE: 'SCHOOL_UPDATE',

  SETTING_UPDATE: 'SETTING_UPDATE',
  SETTING_VIEW: 'SETTING_VIEW',

  ACTIVITY_LOG_VIEW: 'ACTIVITY_LOG_VIEW',

  CARD_OPENING_FEE_CREATE: 'CARD_OPENING_FEE_CREATE',
  CARD_OPENING_FEE_DELETE: 'CARD_OPENING_FEE_DELETE',
  CARD_OPENING_FEE_UPDATE: 'CARD_OPENING_FEE_UPDATE',

  FORM_REGISTER_CONFIRM: 'FORM_REGISTER_CONFIRM',
  FORM_REGISTER_DELETE: 'FORM_REGISTER_DELETE',
  FORM_REGISTER_VIEW: 'FORM_REGISTER_VIEW',

  READER_GROUP_CREATE: 'READER_GROUP_CREATE',
  READER_GROUP_UPDATE: 'READER_GROUP_UPDATE',
  READER_GROUP_DELETE: 'READER_GROUP_DELETE',
  READER_GROUP_VIEW: 'READER_GROUP_VIEW',
};

export const LOCAL_STORAGE_KEYS = {
  LIBRARY_SETTINGS: 'LIBRARY_SETTINGS',
  GUEST_BASKET: 'GUEST_BASKET',
  ACCOUNT: 'ACCOUNT',
  SCHOOL_INFOR: 'SCHOOL_INFOR',
};
